import { HTTPResponseStatus } from "@/utils/enum";
import { useAuth } from "@/utils/useAuth";
import { useAxios } from "@/utils/useAxios";

export async function verifyDocumentExam(file: File) {
  const formData = new FormData();
  formData.append("file", file);

  const response = await useAxios.post(
    `${import.meta.env.VITE_ENDPOINT_N8N}/verifica-exame`,
    formData,
    {
      headers: {
        Authorization: await useAuth.getUserToken(),
        "Content-Type": "application/fhir+json",
        Accept: "application/fhir+json",
      },
    }
  );

  if (response.status !== HTTPResponseStatus.Success) {
    throw new Error("Failed to verify document exam");
  }

  const result = await response.data;

  return result;
}
